import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-profile-picture-with-status',
  templateUrl: './profile-picture-with-status.component.html',
  styleUrls: ['./profile-picture-with-status.component.scss']
})
export class ProfilePictureWithStatusComponent {

  @Input() name: any;
  @Input() userData: any;
  @Input() font: any;
  @Input() isDeactivated: boolean | string = false;
  @Input() type: 'userlist' | 'userdetail' = 'userlist';

  get showDeactivated(): boolean {
    return this.isDeactivated === true || this.isDeactivated === 'true';
  }

  get deactivatedIconSrc(): string {
    switch (this.type) {
      case 'userlist':
        return '../../../../assets/icons/userlist-deactivate.svg';
      case 'userdetail':
        return '../../../../assets/icons/userdetail-deactivate.svg';
      default:
        return '../../../../assets/icons/userlist-deactivate.svg';
    }
  }
}